import { AuditSaleDetails } from "src/app/ui/models/domains/pbm/audit/audit-sale/audit-sale-details";
import { PageableResult } from "../../../../models/domains/paginator/pageable-result";
import { AbstractParser } from "../../parser";
import { parseAuditSaleDetails, parseAuditSalePageableResult } from "./audit-sale-pageable-result-parse-functions";

export class AuditSalePageableResultParser extends AbstractParser<PageableResult> {
  parse(payload: any): PageableResult {
    return parseAuditSalePageableResult(payload);
  }

  parseDetails(payload: any): AuditSaleDetails {
    return parseAuditSaleDetails(payload);
  }
}
